import { memo } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import ReactEchart from '../../../../components/common/ReactEchart';
import StatisticsCardLoading from '../../common/statistic-chart-card/StatisticsChartCardLoading';
import { STATISTICS_EMPTY_CHART_GEO } from '../../common/lib/statisticsEmptyStateCopy';
import StatisticsChartFrame from '../../common/StatisticsChartFrame';
import useStatisticsChinaMapChart, {
	CHINA_MAP_DEFAULT_HEIGHT,
	echarts,
} from '../../common/hooks/useStatisticsChinaMapChart';

const ROOT_CLASS = 'order-primary-phase-china-map';

const OrderPrimaryPhaseChinaMap = ({
	resolveLoadingStyle,
	chartInstanceKeyPrefix = 'china-map',
	wrapperClassName = '',
	...props
}) => {
	const {
		mapWrapRef,
		chartRef,
		mapError,
		isChartLoading,
		isEmpty,
		unknownCount,
		showBack,
		handleBack,
		baseMapOption,
		shouldSetChartOption,
		chartEvents,
		handleChartReady,
		frameStyle,
		loadingStyle,
		echartStyle,
		compact,
		fillSlot,
		animationKey,
	} = useStatisticsChinaMapChart({ ...props, resolveLoadingStyle });

	if (mapError) {
		return <div className={`${ROOT_CLASS}__empty`}>中国地图数据暂不可用</div>;
	}

	if (isChartLoading) {
		return (
			<StatisticsCardLoading
				className={[`${ROOT_CLASS}__loading`, fillSlot ? 'statistics-lite-chart__loading--fill' : null].filter(Boolean).join(' ')}
				style={loadingStyle}
				fill={fillSlot}
				label='加载中国地图…'
			/>
		);
	}

	if (isEmpty) {
		return (
			<div className={`${ROOT_CLASS}__empty statistics-chart-empty`}>
				{STATISTICS_EMPTY_CHART_GEO}
				{unknownCount > 0 ? `（${unknownCount} 单未标注）` : ''}
			</div>
		);
	}

	return (
		<div
			ref={mapWrapRef}
			className={[
				ROOT_CLASS,
				`${ROOT_CLASS}--scroll-through`,
				compact ? `${ROOT_CLASS}--compact` : null,
				fillSlot ? `${ROOT_CLASS}--fill-slot` : null,
				wrapperClassName,
			]
				.filter(Boolean)
				.join(' ')}
		>
			<StatisticsChartFrame fillSlot={fillSlot} style={frameStyle}>
				{showBack ? (
					<Button
						type='button'
						size='sm'
						variant='outline-secondary'
						className={`${ROOT_CLASS}__back${compact ? ` ${ROOT_CLASS}__back--compact` : ''}`}
						onClick={handleBack}
					>
						返回全图
					</Button>
				) : null}
				<ReactEchart
					ref={chartRef}
					key={`${chartInstanceKeyPrefix}-${animationKey}`}
					echarts={echarts}
					option={baseMapOption}
					notMerge={false}
					lazyUpdate={false}
					shouldSetOption={shouldSetChartOption}
					onEvents={chartEvents}
					onChartReady={handleChartReady}
					style={echartStyle}
				/>
			</StatisticsChartFrame>
			{unknownCount > 0 ? <p className={`${ROOT_CLASS}__note mb-0`}>{unknownCount} 单缺少有效客户城市代码，未标注在地图上</p> : null}
		</div>
	);
};

OrderPrimaryPhaseChinaMap.propTypes = {
	resolveLoadingStyle: PropTypes.func,
	chartInstanceKeyPrefix: PropTypes.string,
	wrapperClassName: PropTypes.string,
	provinceRowsOverride: PropTypes.array,
	provinceMetric: PropTypes.string,
	orders: PropTypes.array,
	geoAggregates: PropTypes.object,
	highlightProvinceNames: PropTypes.arrayOf(PropTypes.string),
	highlightAnchorCityRows: PropTypes.array,
	isLoading: PropTypes.bool,
	animationKey: PropTypes.string,
	height: PropTypes.string,
	compact: PropTypes.bool,
	fillSlot: PropTypes.bool,
	fitWideSlot: PropTypes.bool,
	enableOrderDrill: PropTypes.bool,
	onDrillSelect: PropTypes.func,
};

OrderPrimaryPhaseChinaMap.defaultProps = {
	height: CHINA_MAP_DEFAULT_HEIGHT,
};

export default memo(OrderPrimaryPhaseChinaMap);
